///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.edit = abcsetup.consumer_rfp.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.edit = {
    init() {
        abcsetup.setTitle('Edit Consumer RFP Event');

        abcsetup.consumer_rfp.common.init();
        abcsetup.consumer_rfp.common.setupEventBindings();

        $('#preview-modal-btn').on('click', () => {
            // render preview of rfp other stuff
            // type
            $('#rfp_type').html($('#app_models_consumer_r_f_p__consumer_rfp_type_id option:selected').text());
            // date range
            $('#rfp_date_range').html($('#app_models_consumer_r_f_p__start_date').val() + ' - ' + $('#app_models_consumer_r_f_p__end_date').val())
            // reminder in days
            $('#rfp_reminder_in_days').html($('#app_models_consumer_r_f_p__reminder_in_days').val());
            // rfp name
            $('#rfp_name').html($('#app_models_consumer_r_f_p__name').val());
            // instructions
            $('#rfp_instructions').html($('#app_models_consumer_r_f_p__instructions').val());
            // items
            $('#rfp_items').empty();

            // item setup deadlines
            $('#rfp_items').append('<p>' + $('#item_setup_deadline_table').parent().parent().find('label').html() + '</p>');
            let content = '';
            $('#item_setup_deadline_table tr').each(function() {
                const item = $(this).find('td:eq(0)').text().trim();
                if(item.length == 0)
                    return;
                content += '<li>' + $(this).find('td:eq(0)').text() + ': ' + $(this).find('td:eq(1)').find('input').val() + '</li>';
            });
            $('#rfp_items').append('<ul>' + content + '</ul>');

            // item setup deadlines
            $('#rfp_items').append('<p>' + $('#item_inventory_deadline_table').parent().parent().find('label').html() + '</p>');
            content = '';
            $('#item_inventory_deadline_table tr').each(function() {
                const item = $(this).find('td:eq(0)').text().trim();
                if(item.length == 0)
                    return;
                content += '<li>' + $(this).find('td:eq(0)').text() + ': ' + $(this).find('td:eq(1)').find('input').val() + '</li>';
            });
            $('#rfp_items').append('<ul>' + content + '</ul>');

            // active ingredients
            $('#rfp_items').append('<p>' + $('#active_ingredient_table').parent().parent().find('label').html() + '</p>');
            content = '';
            $('#active_ingredient_table tr').each(function() {
                const item = $(this).find('td:eq(0)').text().trim();
                if(item.length == 0)
                    return;
                content += '<li>' + $(this).find('td:eq(0)').text() + ': ' + $(this).find('td:eq(1)').find('input').val() + '</li>';
            });
            $('#rfp_items').append('<ul>' + content + '</ul>');

            // compare to
            $('#rfp_items').append('<p>' + $('#compare_to_table').parent().parent().find('label').html() + '</p>');
            content = '';
            $('#compare_to_table tr').each(function() {
                const item = $(this).find('td:eq(0)').text().trim();
                if(item.length == 0)
                    return;
                content += '<li>' + $(this).find('td:eq(0)').text() + ': ' + $(this).find('td:eq(1)').find('input').val() + '</li>';
            });
            $('#rfp_items').append('<ul>' + content + '</ul>');

            // estimated volume for upcoming year
            $('#rfp_items').append('<p>' + $('#estimated_upcoming_volume_table').parent().parent().find('label').html() + '</p>');
            content = '';
            $('#estimated_upcoming_volume_table tr').each(function() {
                const item = $(this).find('td:eq(0)').text().trim();
                if(item.length == 0)
                    return;
                content += '<li>' + $(this).find('td:eq(0)').text() + ': ' + $(this).find('td:eq(1)').find('input').val() + '</li>';
            });
            $('#rfp_items').append('<ul>' + content + '</ul>');

            // suppliers
            let selected_suppliers = '';
            if($('#app_models_consumer_r_f_p__all_suppliers').is(':checked')) {
                selected_suppliers = 'All Suppliers';
            } else {
                const suppliers = $('#app_models_consumer_r_f_p_supplier__supplier_ids').select2('data');
                let suppliers_arr = []
                $.each(suppliers, function(idx, supplier) {
                    suppliers_arr.push(supplier.text);
                });
                selected_suppliers = '<ul><li>' + suppliers_arr.join('</li><li>') + '</li></ul>';
            }
            $('#rfp_suppliers').html(selected_suppliers);

            // new suppliers
            let selected_new_suppliers = '';
            const new_suppliers = $('#app_models_consumer_r_f_p_new_supplier__new_supplier_emails').select2('data');
            let new_suppliers_arr = []
            $.each(new_suppliers, function(idx, new_supplier) {
                new_suppliers_arr.push(new_supplier.id);
            });
            selected_new_suppliers = '<ul><li>' + new_suppliers_arr.join('</li><li>') + '</li></ul>';
            $('#rfp_new_suppliers').html(selected_new_suppliers);


            // render preview of form builder
            const container = $('#rendered-form');
            const formData = abcsetup.consumer_rfp.common.formBuilder.actions.getData();
            const renderOptions = {
                container,
                formData,
                dataType: 'json'
            };
            $(container).formRender(renderOptions);
        });

        $('#save-template-btn').on('click', () => {
            const template_name = $('#template-name').val();
            if(template_name.length == 0) {
                $('#template-name').addClass('invalid');
                return false;
            }
            const formData = abcsetup.consumer_rfp.common.formBuilder.actions.getData();
            const params = {
                name: $('#template-name').val(),
                form_data: formData
            };
            abcsetup.blockUI('show');
            axios.post('/api/consumer_rfp/fb', params)
                .then((response) => {
                    if(!response.data.error) {
                        abcsetup.alerts.flashMessage(response.data.message);
                    } else {
                        abcsetup.alerts.flashMessage('An error occurred', 'error');
                    }
                    abcsetup.unblockUI();
                })
                .catch((error) => {
                    abcsetup.unblockUI();
                });
        });

        $('#form_builder_template').on('change', function() {
            if($(this).val()) {
                abcsetup.blockUI('show');
                axios.get('/api/consumer_rfp/fb/' + $(this).val())
                    .then((response) => {
                        console.log(JSON.stringify(response.data));
                        if(response.data.form_data) {
                            abcsetup.consumer_rfp.common.formBuilder.actions.setData(response.data.form_data);
                        }
                        abcsetup.unblockUI();
                    })
                    .catch((error) => {
                        abcsetup.unblockUI();
                    });
            } else {
                abcsetup.consumer_rfp.common.formBuilder.actions.clearFields();
            }
        });
    },

    fieldsInit() {
        $('#app_models_consumer_r_f_p__all_suppliers').trigger('change');
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the callback
     */
    uploadDone() {
        if (abcsetup.uploader.uploadResult.type === 'importSuppliers') {
            abcsetup.consumer_rfp.common.importSuppliers(abcsetup.uploader.uploadResult.vals);
        } else if (abcsetup.uploader.uploadResult.type === 'importItems') {
            abcsetup.consumer_rfp.common.importItems(abcsetup.uploader.uploadResult.vals, abcsetup.uploader.uploadResult.extras);
        }
    },
}
